"use client"

import { FolderOpen, Package } from "lucide-react"

interface EmptyStateProps {
  type: "folders" | "projects"
}

export function EmptyState({ type }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-24">
      {type === "folders" ? (
        <FolderOpen className="mb-4 size-16 text-muted-foreground/40" />
      ) : (
        <Package className="mb-4 size-16 text-muted-foreground/40" />
      )}
      <h3 className="text-lg font-medium text-foreground">
        {type === "folders" ? "Nenhuma pasta" : "Nenhum projeto"}
      </h3>
      <p className="mt-1 max-w-xs text-center text-sm text-muted-foreground">
        {type === "folders"
          ? 'Crie sua primeira pasta clicando em "Nova Pasta" acima.'
          : 'Vincule projetos a esta pasta pelo menu "Vincular Projetos".'}
      </p>
    </div>
  )
}
